// extracted by mini-css-extract-plugin
export default {"TwoDimsListFeature":"wb_a bhe_b","TwoDimsListFeature__item":"wb_b bhe_wb","TwoDimsListFeature__item__text":"wb_c bhe_vr"};